import { Injectable } from '@angular/core';

/**
 * Get actual window object
 * Istanbul ignore because no sense to test window on unit tests.
 * @returns {any}
 */
/* istanbul ignore next */
function getWindow(): Window {
  return window;
}

/**
 * Provider service for native Window object. Service is used because it's easy to mock in tests.
 * Istanbul ignore because no sense to test window on unit tests.
 */
@Injectable()
/* istanbul ignore next */
export class WindowRefService {
  /**
   * Return window object, any used as type to bypass Typescript compiler errors.
   * Istanbul ignore because no sense to test window on unit tests.
   * @returns {any}
   */
  /* istanbul ignore next */
  get nativeWindow(): any {
    return getWindow();
  }
}
